/* Keeps the announcement-bar free-shipping message ([data-fsa], see snippets/announcement-free-shipping.liquid)
   in sync with the cart. The snippet renders once per slide (plus swiper's loop clones), and may include this
   script more than once, so it guards itself and always updates every [data-fsa] on the page. */
(() => {
  if (window.__fsaInit) return;
  window.__fsaInit = true;

  const money = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

  function render(cart) {
    document.querySelectorAll('[data-fsa]').forEach((el) => {
      const threshold = parseInt(el.dataset.threshold, 10);
      const live = cart.item_count > 0 && cart.currency === 'USD';
      const remaining = threshold - cart.total_price;
      const pct = Math.min(100, Math.floor((cart.total_price * 100) / threshold));

      el.classList.toggle('fsa--live', live);
      el.classList.toggle('fsa--done', live && remaining <= 0);
      el.querySelector('.fsa__msg').textContent = !live
        ? el.dataset.default
        : remaining <= 0
          ? "You've unlocked free shipping!"
          : `You're ${money(remaining)} away from free shipping`;
      el.querySelector('.fsa__fill').style.width = `${live ? pct : 0}%`;
    });
  }

  function refresh() {
    fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(render)
      .catch(() => {});
  }

  // The theme publishes cart-update after add-to-cart (product-form.js) and quantity changes/removals (cart.js).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  // Back/forward cache restores a stale page; re-sync.
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
})();
